import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C01AccordionItemProps = RenderingProps<
  C01AccordionItemFields,
  C01AccordionItemRenderingParams
>;

export type C01AccordionItemFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
};

export type C01AccordionItemRenderingParams = TranslationOptionsParams & AnchorTargetParams;
